import React from 'react';
import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray1000Base, colorCoreGray300, colorCoreGray500, colorCoreGray800, colorCoreWhite1000, colorWhiteTransparent300, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
export const SimpleDropDownStyled = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: transparent;

  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  width: ${({ defaultDropDownWidth }) => defaultDropDownWidth};
`;
export const DropDownStyled = styled.div `
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 44px;
  overflow: hidden;

  gap: 8px;

  padding: 10px 10px 10px 12px; /* TODO: need improve this styles/approach for RTL option */

  border-radius: ${CORNER_RADIUS.s};
  color: ${colorCoreBlack900Base};
  background-color: ${colorWhiteTransparent300};

  border-style: solid;
  border-width: 1px;
  border-color: ${({ isDropDownExpanded }) => isDropDownExpanded ? colorCoreGray800 : colorCoreGray500};

  ${({ isDisabled }) => isDisabled &&
    css `
      background: ${colorWhiteTransparent300};
      border: 1px solid ${colorCoreGray500};
      color: ${colorCoreGray1000Base};
      cursor: not-allowed;

      span {
        color: ${colorCoreGray1000Base};
      }
      path {
        fill: ${colorCoreGray1000Base};
      }
    `}

  &:hover {
    border-color: ${colorCoreGray800};
  }
`;
export const DropDownListWrapperStyled = styled.div `
  position: absolute;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  display: ${({ isDropDownExpanded }) => (isDropDownExpanded ? 'flex' : 'none')};
  z-index: ${Z_INDEX.level2};
  border-radius: ${CORNER_RADIUS.m};
  background-color: ${colorCoreWhite1000};

  ${({ isTopDirection }) => isTopDirection
    ? css `
          bottom: 100%;
          margin-bottom: 8px;

          & > ul {
            display: flex;
            flex-flow: column-reverse;
          }
        `
    : css `
          margin-top: 8px;
          top: 100%;
        `};
`;
export const DropDownListStyled = styled.ul `
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style: none;

  box-shadow: ${elevationBottomLvl2};
  border-radius: ${CORNER_RADIUS.m};

  ${({ withScroll }) => (withScroll ? CustomScroll : 'padding: 6px;')}

  ${({ customMaxHeight }) => customMaxHeight && `max-height: ${customMaxHeight};`}
`;
export const DropDownItemStyled = styled.li `
  display: flex;
  flex-direction: row;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  padding: 10px 12px;
  width: 100%;
  cursor: pointer;

  border-radius: ${CORNER_RADIUS.xs};
  color: ${colorCoreBlack900Base};
  background-color: ${defaultTransparent};

  ${({ isActiveTab }) => isActiveTab && `background-color: ${colorBlackTransparent50};`}

  &:hover {
    background-color: ${colorCoreGray300};
  }

  ${({ isDisabled }) => isDisabled &&
    css `
      background-color: ${colorWhiteTransparent300};
      cursor: not-allowed;

      span {
        color: ${colorCoreGray1000Base};
      }
    `}
`;
export const SVGIconStyled = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
({ isDropDownExpanded, ...props }) => React.createElement(SVGIcon, { ...props })) `
  transform: ${({ isDropDownExpanded }) => isDropDownExpanded ? 'rotate(0deg)' : 'rotate(180deg)'};
`;
export const SelectedOptionTitleStyled = styled(RegularTextLevel4) `
  ${ADAPTIVE.maxWidth.mobile} {
    white-space: normal;
  }
`;
